// src/pages/Favorites.js
// Page des favoris - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import { useListings } from '../hooks/useListings';

const Favorites = () => {
  const { t } = useTranslation();
  const { getFavorites } = useListings();
  const [favoriteListings, setFavoriteListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Récupérer les IDs des favoris
    const favoriteIds = getFavorites();

    // Données de démo (à remplacer par appel API filtré sur les IDs)
    const allDemoListings = [
      {
        id: 1,
        slug: 'appartement-moderne-bonapriso-1',
        title: 'Appartement moderne meublé',
        quartier: 'Bonapriso',
        city: 'Douala',
        price: 250000,
        priceType: 'perMonth',
        category: 'locations',
        images: ['/images/placeholder.png'],
        bedrooms: 2,
        bathrooms: 1,
        area: 85,
      },
      {
        id: 2,
        slug: 'studio-meuble-akwa-2',
        title: 'Studio meublé centre-ville',
        quartier: 'Akwa',
        city: 'Douala',
        price: 25000,
        priceType: 'perNight',
        category: 'sejours',
        images: ['/images/placeholder.png'],
        bedrooms: 1,
        bathrooms: 1,
        area: 40,
      },
      {
        id: 3,
        slug: 'terrain-viabilise-logpom-3',
        title: 'Terrain viabilisé titre foncier',
        quartier: 'Logpom',
        city: 'Douala',
        price: 25000,
        priceType: 'perSquareMeter',
        category: 'immobilier',
        images: ['/images/placeholder.png'],
        area: 500,
      },
      {
        id: 4,
        slug: 'villa-luxe-bastos-4',
        title: 'Villa de luxe avec piscine',
        quartier: 'Bastos',
        city: 'Yaoundé',
        price: 500000,
        priceType: 'perMonth',
        category: 'locations',
        images: ['/images/placeholder.png'],
        bedrooms: 4,
        bathrooms: 3,
        area: 250,
      },
    ];

    // Filtrer sur les favoris
    const filtered = allDemoListings.filter((listing) =>
      favoriteIds.includes(listing.id)
    );
    setFavoriteListings(filtered);
    setLoading(false);
  }, [getFavorites]);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    title: { fontSize: '22px', fontWeight: '700', color: '#FFFFFF' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: '#A0AEC0' },
    emptyContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px 24px',
      textAlign: 'center',
      gap: '12px',
    },
    emptyIcon: { fontSize: '56px', opacity: 0.4 },
    emptyTitle: { fontSize: '16px', fontWeight: '600', color: '#FFFFFF' },
    emptyText: { fontSize: '14px', color: '#A0AEC0', maxWidth: '280px', lineHeight: '1.5' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Mes favoris | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <div style={styles.title}>❤️ {t('nav.favorites')}</div>
      </div>

      {favoriteListings.length > 0 ? (
        <>
          <div style={styles.subtitle}>
            {favoriteListings.length} {favoriteListings.length > 1 ? 'annonces sauvegardées' : 'annonce sauvegardée'}
          </div>
          <ListingGrid listings={favoriteListings} loading={loading} />
        </>
      ) : (
        <div style={styles.emptyContainer}>
          <div style={styles.emptyIcon}>🤍</div>
          <div style={styles.emptyTitle}>Aucun favori pour l'instant</div>
          <div style={styles.emptyText}>
            Appuyez sur le cœur d'une annonce pour la sauvegarder ici et la retrouver facilement.
          </div>
        </div>
      )}
    </div>
  );
};

export default Favorites;